import { useContext } from 'react'
import { GlobalSearchContext } from '../context/GlobalSearchContext'
import useGoBackState from 'shared/hooks/useGoBackState'
import { GlobalSearch, IconFile } from '@bbl-digital/snorre-v2'
import { getFileIcon } from 'shared/utils/file/fileIcon'

export const ProsjektarkivDocumentSearchHits = () => {
  const { loading, prosjektarkivDocumentHits } = useContext(GlobalSearchContext)
  const { push } = useGoBackState()

  const hasHits = prosjektarkivDocumentHits?.hits?.length

  const goToDocument = (id: string) => {
    push(`/styrearbeid/arkiv/prosjektarkiv/${id}`)
  }

  if (loading || !hasHits) return null

  const mapHighlights = (highlights: string[]) => {
    return highlights?.map((highlight) => ({ key: 'text', value: [highlight] }))
  }

  const Hits = () => {
    return prosjektarkivDocumentHits.hits?.map((item) => (
      <GlobalSearch.Item
        key={item.id}
        label={item.title}
        subtitle={item.filename}
        highlights={mapHighlights(item.highlightsText) || []}
        options={{
          renderHighlightsAsHtml: true,
        }}
        icon={
          <>
            {item.mimeType ? (
              <div className="flex items-center justify-center bg-surface-common-icon-highlight p-[4px] pr-[3px] min-h-[20px] min-w-[20px] rounded-card [&>svg]:!fill-surface-common-icon-color">
                {getFileIcon(item.mimeType, {
                  size: 22,
                })}
              </div>
            ) : (
              <IconFile colorVariant="primary" backgrounded />
            )}
          </>
        }
        onClick={() => goToDocument(item.id)}
      />
    ))
  }

  return (
    <GlobalSearch.Group label="Prosjektarkiv" title="Prosjektarkiv">
      <Hits />
    </GlobalSearch.Group>
  )
}
